import React from 'react';

const RevolvingGlobe: React.FC = () => {
  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="relative w-20 h-20"> {/* Increased size by 20% */}
        {/* The 'P' letter on top */}
        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 z-20">
          <span className="text-3xl font-bold text-accent-blue">P</span> {/* Increased font size by ~20% */}
        </div>
        
        {/* Rotating orbit container */}
        <div className="absolute inset-0 animate-spin-slow">
          {/* Orbit track */}
          <div className="absolute inset-0 border border-accent-blue/30 rounded-full"></div>
          
          {/* Orbiting dot */}
          <div className="absolute top-0 left-1/2 w-3 h-3 rounded-full bg-accent-blue -translate-y-1/2 -translate-x-1/2"></div>
        </div>
        
        {/* Globe itself at center */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-gradient-to-r from-accent-blue/20 to-navy-blue/30 border border-accent-blue/50 flex items-center justify-center">
          <div className="w-7 h-7 rounded-full bg-gradient-to-r from-accent-blue/40 to-navy-blue/40 border border-accent-blue/30"></div>
        </div>
      </div>
    </div>
  );
};

export default RevolvingGlobe;